import { z } from 'zod';
import { PaymentType, TournamentType } from '@/types/tournament.model';

/**
 * Validation schema for the Pricing step.
 */
export const pricingStepSchema = z.object({
  price: z.object({
    id: z.string(),
    value: z.number().min(0, 'El precio no puede ser negativo'),
    currency: z.object({
      isoCode: z.string(),
      name: z.string(),
    }),
  }),
  paymentType: z.nativeEnum(PaymentType, {
    errorMap: () => ({ message: 'Selecciona un método de pago' }),
  }),
  type: z.nativeEnum(TournamentType).optional(),
});

export type PricingStepData = z.infer<typeof pricingStepSchema>;
